module.exports = __webpack_public_path__ + "img/alert-triangle.280a867a.svg";